import { render, staticRenderFns } from "./mianView.vue?vue&type=template&id=dda4d144&scoped=true"
import script from "./mianView.vue?vue&type=script&lang=js"
export * from "./mianView.vue?vue&type=script&lang=js"
import style0 from "./mianView.vue?vue&type=style&index=0&id=dda4d144&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda4d144",
  null
  
)

export default component.exports